import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GppGoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gpp_good"}/>
}
